/* eslint-disable */
export default function init(Blockly, profile) {
    Blockly.Arduino.io = {};

    /**
     * ***************************************************************************
     * IO_PINMODE code generator definition
     * ***************************************************************************
     */
    Blockly.Arduino.io_pinmode = function() {
        var a = Blockly.Arduino.nameDB_.getName(this.getFieldValue("VAR"),
                                                Blockly.VARIABLE_CATEGORY_NAME),
            b = this.getFieldValue("MODE");
        return "pinMode(" + a + ", " + b + ");\n"
    };

    /**
     * ***************************************************************************
     * IO_DIGITAL_WRITE code generator definition
     * ***************************************************************************
     */
    Blockly.Arduino.io_digital_write = function() {
        var a = this.getFieldValue("PIN"),
            b = this.getFieldValue("STAT");
        Blockly.Arduino.setups_["setup_output_" + a] = "pinMode(" + a + ", OUTPUT);";
        return "digitalWrite(" + a + ", " + b + ");\n"
    };
    /**
     * ***************************************************************************
     * IO_DIGITAL_WRITE with variable code generator definition
     * ***************************************************************************
     */
    Blockly.Arduino.io_digital_write_var = function() {

        const pin = Blockly.Arduino.valueToCode(this, "PIN", Blockly.Arduino.ORDER_ATOMIC) || "0";
        const state = Blockly.Arduino.valueToCode(this, "STAT", Blockly.Arduino.ORDER_ATOMIC) || "false";

        Blockly.Arduino.definitions_fnc_.function_digital_write =
          "void function_digital_write(int _pin, int state) {\n" +
          "  pinMode(_pin, OUTPUT);\n" +
          "  digitalWrite(_pin, state);\n" +
          "}\n\n";

        return "function_digital_write(" + pin + ", " + state + ");\n";
    };

    /**
     * ***************************************************************************
     * IO_DIGITAL_READ code generator definition
     * ***************************************************************************
     */
    Blockly.Arduino.io_digital_read = function() {
        var a = this.getFieldValue("PIN");
        Blockly.Arduino.setups_["setup_input_" + a] = "pinMode(" + a + ", INPUT);";

        return ["digitalRead(" + a + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.io_digital_read_pin = function() {
        var pin = Blockly.Arduino.valueToCode(this, "PIN", Blockly.Arduino.ORDER_ATOMIC) || "0";
        Blockly.Arduino.definitions_fnc_.fnc_dynamic_digitalRead =
        "int fnc_dynamic_digitalRead(int _pin) {\n" +
        "  pinMode(_pin, INPUT);\n" +
        "  return digitalRead(_pin);\n" +
        "}\n\n";
        return ["fnc_dynamic_digitalRead(" + pin + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.io_analog_write = function() {
        var a = this.getFieldValue("PIN"),
            b = Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC);
        Blockly.Arduino.setups_["setup_output_" + a] = "pinMode(" + a + ", OUTPUT);";
        return "analogWrite(" + a + ", " + b + ");\n"
    };
    Blockly.Arduino.io_analog_write_pin = function() {
        var a = Blockly.Arduino.valueToCode(this, "PIN", Blockly.Arduino.ORDER_ATOMIC) || "0",
            b = Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC) || "0";
        Blockly.Arduino.definitions_fnc_.fnc_dynamic_analogWrite =
        "void fnc_dynamic_analogWrite(int _pin, int _e) {\n" +
        "  pinMode(_pin,OUTPUT);\n" +
        "  analogWrite(_pin,_e);\n" +
        "}\n\n";
        return "fnc_dynamic_analogWrite(" +
            a + ", " + b + ");\n"
    };
    Blockly.Arduino.io_analog_read = function() {
        var a = this.getFieldValue("PIN");
        Blockly.Arduino.setups_["setup_input_" + a] = "pinMode(" + a + ", INPUT);";
        return ["analogRead(" + a + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.io_analog_read_pin = function() {
        var a = Blockly.Arduino.valueToCode(this, "PIN", Blockly.Arduino.ORDER_ATOMIC) || "0";
        Blockly.Arduino.definitions_fnc_.fnc_dynamic_analogRead =
        "int fnc_dynamic_analogRead(int _pin) {\n" +
        "  pinMode(_pin,INPUT);\n" +
        "  return analogRead(_pin);\n" +
        "}\n\n";
        return ["fnc_dynamic_analogRead(" + a + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.io_capacitive_read = function() {
        return ["touchRead(" + this.getFieldValue("PIN") + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.io_pulsein = function() {
        var a = this.getFieldValue("PIN"),
            b = this.getFieldValue("STAT"),
            c = Blockly.Arduino.valueToCode(this, "TIMEOUT", Blockly.Arduino.ORDER_ATOMIC) || "0";
        return ["pulseIn(" + a + ", " + ("true" == b || "false" == b || "HIGH" == b || "LOW" == b ? "true" == b || "HIGH" == b ? "HIGH" : "LOW" : "(" + b + "!=0)") + ", " + c + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.io_interrupt = function() {
        var a = this.getFieldValue("PIN"),
            b = this.getFieldValue("MODE"),
            c = Blockly.Arduino.statementToCode(this, "DO");
        Blockly.Arduino.setups_["setup_input_" + a] = "pinMode(" + a + ", INPUT);";
        Blockly.Arduino.setups_["setup_interruptHandler_" + a] = "attachInterrupt(digitalPinToInterrupt(" + a + "), fnc_interruptHandler_" + a + ", " + b + ");";
        b = "esp8266" == profile["default"].micro ? "void ICACHE_RAM_ATTR fnc_interruptHandler_" + a + "() {\r\n" : "esp32" == profile["default"].micro ? "void IRAM_ATTR fnc_interruptHandler_" +
            a + "(){\r\n" : "void fnc_interruptHandler_" + a + "() {\r\n";
        Blockly.Arduino.definitions_fnc_["fnc_interruptHandler_" + a] = b + (c + "\n}\n\n");
        return ""
    };
}